<template>
    <section>
        <router-view></router-view>
    </section>
</template>

<script>
    import { mapGetters } from "vuex"
    export default {
        name: "app",
    }
</script>


// WEBPACK FOOTER //
// src/App.vue